import React from "react";
import MOTPerformanceReport from "./MOTPerformanceReport";

// IR dashboard — same lead/agent performance component, team="IR".
// Column headers/title come from the API's `labels` for the IR team.
const IRPerformanceReport = (props) => (
    <MOTPerformanceReport {...props} team="IR" title="IR Performance Report" />
);

export default IRPerformanceReport;
